module.exports = __webpack_public_path__ + "img/家用电器1.3395a7a5.jpg";